import { useServiceWorker } from '@/hooks/use-service-worker';
import { Button } from '@/components/ui/button';
import { X, RefreshCw } from 'lucide-react';
import { useState } from 'react';

export function UpdateNotification() {
  const { hasUpdate, updateApp } = useServiceWorker();
  const [dismissed, setDismissed] = useState(false);

  if (!hasUpdate || dismissed) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 z-50 max-w-md animate-in slide-in-from-bottom-5">
      <div className="bg-gradient-to-r from-violet-600 to-purple-600 text-white rounded-lg shadow-2xl p-4 flex items-center gap-3">
        <div className="flex-shrink-0">
          <RefreshCw className="h-6 w-6" />
        </div>
        
        <div className="flex-1 min-w-0">
          <p className="font-semibold text-sm">Nueva versión disponible</p>
          <p className="text-xs text-violet-100 mt-0.5">
            Actualiza para obtener las últimas mejoras
          </p>
        </div>
        
        <div className="flex items-center gap-2">
          <Button
            onClick={updateApp}
            size="sm"
            variant="secondary"
            className="bg-white text-violet-600 hover:bg-violet-50 font-semibold"
          >
            Actualizar
          </Button>
          
          <button
            onClick={() => setDismissed(true)}
            className="text-white/80 hover:text-white hover:bg-white/10 transition-colors p-2 rounded-lg min-h-[44px] min-w-[44px] flex items-center justify-center"
            aria-label="Cerrar notificacion"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
      </div>
    </div>
  );
}
